export class RoleType {

    public static ADMIN: number = 1;
    public static CONSULTANT: number = 2;
    public static RESPONDENT: number = 3;
}
